import _typeof from "D:\\ax2\\deployment\\ax2new\\AccessExpress\\web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/typeof";

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;
export default freeGlobal;